import { createSlice } from '@reduxjs/toolkit';

const NAME = 'auth';
const DEFAULT_LANGUAGE = 'pt';

const authSlice = createSlice({
  name: NAME,
  initialState: {
    role: null,
    loading: null,
    error: { hasError: false, state: NAME },
    isLoggedIn: false,
    id: null,
    name: null,
    email: null,
    language: DEFAULT_LANGUAGE,
    filters: [],
    timeout: null
  },
  reducers: {
    setIsLoggedIn(state, action) {
      state.isLoggedIn = action.payload;
    },
    setUser: (state, action) => {
      const { name, email, role, language, userId } = action.payload;
      state.isLoggedIn = true;
      state.id = userId;

      if (name && name !== state.name) {
        state.name = name;
      }
      if (role && role !== state.role) {
        state.role = role;
      }
      if (email && email !== state.email) {
        state.email = email;
      }
      if (language && language !== state.language) {
        state.language = language;
      }
    },
    setTimeout: (state, action) => {
      state.timeout = action.payload;
    },
    logout: (state, action) => {
      state.isLoggedIn = false;
      state.name = null;
      state.email = null;
      state.role = null;
      state.language = DEFAULT_LANGUAGE;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    saveFilter: (state, action) => {
      state.filters = action.payload;
    },
    editFilter: (state, action) => {
      state.filters = action.payload;
    },
    deleteFilter: (state, action) => {
      state.filters = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      const { status, message, type } = action.payload;
      state.error.hasError = true;
      state.error.code = status;
      state.error.message = message;
      state.error.type = type;
    },
    cleanErrors: (state, action) => {
      state.error = { hasError: false, state: NAME };
    },
    cleanState: state => {
      state.id = null;
      state.name = null;
      state.email = null;
      state.language = DEFAULT_LANGUAGE;
      state.filters = [];
      state.error = { hasError: false, state: NAME };
    }
  }
});

export const authActions = authSlice.actions;
export default authSlice;
